import { useEffect } from 'react';
import { ICS2ArrivalView } from 'store/declarations/eu/ics2/arrival/ics2-arrival-notification-declaration';

const REFRESH_DELAY_TIME = 60000;

const useArrivalAutoRefresh = (
    arrival: ICS2ArrivalView | undefined,
    load: (id: string) => Promise<unknown>,
    loadMessages: (id: string) => Promise<unknown>
) => {
    const id = arrival?.id;
    const status = arrival?.status;

    useEffect(() => {
        if (!id || status === 'DRAFT') return undefined;

        const interval = setInterval(() => {
            Promise.all([load(id), loadMessages(id)]).catch(() => {});
        }, REFRESH_DELAY_TIME);

        return () => clearInterval(interval);
    }, [id, status, load, loadMessages]);
};

export default useArrivalAutoRefresh;
